import { render, staticRenderFns } from "./NotificationCompetitorThread.vue?vue&type=template&id=52e350b8&scoped=true"
import script from "./NotificationCompetitorThread.vue?vue&type=script&lang=js"
export * from "./NotificationCompetitorThread.vue?vue&type=script&lang=js"
import style0 from "./NotificationCompetitorThread.vue?vue&type=style&index=0&id=52e350b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e350b8",
  null
  
)

export default component.exports